<template>
    <div class="download">
        <div class="title">
            下载
            <div class="line"></div>
        </div>
        <el-row :gutter="10" >
            <el-col :xs="12" :sm="12" :md="8" :lg="6" v-for="item in list" :key="item.id" class="lie">
                <img src="./../assets/img/6icon1.png" class="icon" alt="">
                <a href="item.url">{{item.name}}</a>
            </el-col>
        </el-row>
    </div>
</template>

<script>
  export default {
    data() {
      return {
        list: [
          {id: '1', name: '下载1', url: ''},
          {id: '2', name: '下载2', url: ''},
          {id: '3', name: '下载3', url: ''},
          {id: '4', name: '下载4', url: ''},
          {id: '5', name: '下载5', url: ''},
          {id: '6', name: '下载6', url: ''},
          {id: '7', name: '下载7', url: ''},
          {id: '8', name: '下载8', url: ''}
        ]
      }
    }
  }
</script>

<style scoped lang="less">
    .download {
        padding: 92px 200px;
        background: url(../assets/img/page6bg.png) no-repeat center 200px #f9f9f7;
        background-size: 348px 192px;
    }

    .title {
        text-align: center;
        font-size: 34px;
        color: #595757;
        padding-bottom: 40px;
    }

    .line {
        width: 103px;
        background: #e5d276;
        height: 4px;
        margin: 10px auto;
    }

    .hang {
        padding-top: 20px;
    }

    .lie {
        margin-top: 20px;
        display: flex;
        justify-content: center; /*主轴上居中*/
        align-items: center; /*侧轴居中*/

        > a {
            padding-left: 5px;
            color: #4c4c4c;
            text-decoration: none;
        }
    }
</style>
